import type { CasOrCategory } from '../types/db.ts';

// From: https://www.epa.gov/system/files/documents/2026-03/ry_2025_tri_chemical_list_3.10.26.xlsx
export const pfasSet = new Set<CasOrCategory>([
  '10495-86-0',
  '1078142-10-5',
  '1078712-88-5',
  '1078715-61-3',
  '118400-71-8',
  '123171-68-6',
  '125476-71-3',
  '13252-13-6',
  '135228-60-3',
  '142636-88-2',
  '143372-54-7',
  '148240-85-1',
  '148240-87-3',
  '148240-89-5',
  '150135-57-2',
  '16517-11-6',
  '1652-63-7',
  '1691-99-2',
  '17202-41-4',
  '1763-23-1',
  '17741-60-5',
  '178094-69-4',
  '178535-23-4',
  '180582-79-0',
  '182176-52-9',
  '196316-34-4',
  '1996-88-9',
  '200513-42-4',
  '203743-03-7',
  '2043-53-0',
  '2043-54-1',
  '2144-54-9',
  '21615-47-4',
  '21652-58-4',
  '2218-54-4',
  '2263-09-4',
  '238420-68-3',
  '238420-80-9',
  '2395-00-8',
  '24448-09-7',
  '25268-77-3',
  '2728655-42-1',
  '2738952-61-7',
  '2742694-36-4',
  '2744262-09-5',
  '27619-90-5',
  '27619-91-6',
  '27619-94-9',
  '27619-97-2',
  '27905-45-9',
  '2795-39-3',
  '2816091-53-7',
  '29081-56-9',
  '29117-08-6',
  '2923-26-4',
  '29420-49-3',
  '29457-72-5',
  '2966-54-3',
  '2991-51-7',
  '30046-31-2',
  '3030471-22-5',
  '307-24-4',
  '307-35-7',
  '307-55-1',
  '3107-18-4',
  '3108-42-7',
  '31506-32-8',
  '335-66-0',
  '335-67-1',
  '335-71-7',
  '335-76-2',
  '335-93-3',
  '335-95-5',
  '34362-49-7',
  '34395-24-9',
  '355-46-4',
  '37338-48-0',
  '375-22-4',
  '375-73-5',
  '375-95-1',
  '376-06-7',
  '376-14-7',
  '376-27-2',
  '377-73-1',
  '38006-74-5',
  '3825-26-1',
  '383-07-3',
  '3830-45-3',
  '3871-99-6',
  '3872-25-1',
  '39239-77-5',
  '4151-50-2',
  '422-64-0',
  '423-82-5',
  '425670-75-3',
  '45048-62-2',
  '45187-15-3',
  '4980-53-4',
  '507-63-1',
  '52166-82-2',
  '55910-10-6',
  '56372-23-7',
  '56773-42-3',
  '59071-10-2',
  '59587-38-1',
  '59587-39-2',
  '6014-75-1',
  '60270-55-5',
  '60699-51-6',
  '61660-12-6',
  '61798-68-3',
  '62037-80-3',
  '65104-45-2',
  '65104-65-6',
  '65104-67-8',
  '65510-55-6',
  '65530-59-8',
  '65530-61-2',
  '65530-62-3',
  '65530-63-4',
  '65530-64-5',
  '65530-65-6',
  '65530-66-7',
  '65530-69-0',
  '65530-70-3',
  '65530-71-4',
  '65530-72-5',
  '65530-74-7',
  '65530-83-8',
  '65545-80-4',
  '65605-56-3',
  '65605-57-4',
  '65605-58-5',
  '65605-59-6',
  '65605-73-4',
  '65636-35-3',
  '67584-42-3',
  '67584-52-5',
  '67584-53-6',
  '67584-56-9',
  '67584-57-0',
  '67584-58-1',
  '67584-62-7',
  '678-39-7',
  '67905-19-5',
  '67906-42-7',
  '67969-69-1',
  '68084-62-8',
  '68140-18-1',
  '68140-20-5',
  '68140-21-6',
  '68141-02-6',
  '68156-01-4',
  '68156-07-0',
  '68187-25-7',
  '68187-47-3',
  '68188-12-5',
  '68227-96-3',
  '68239-43-0',
  '68259-07-4',
  '68259-08-5',
  '68259-09-6',
  '68259-38-1',
  '68259-39-2',
  '68298-62-4',
  '68298-80-6',
  '68298-81-7',
  '68310-17-8',
  '68391-08-2',
  '68412-68-0',
  '68412-69-1',
  '68515-62-8',
  '68555-74-8',
  '68555-75-9',
  '68555-76-0',
  '68555-81-7',
  '68555-91-9',
  '68758-57-6',
  '68867-60-7',
  '68957-55-1',
  '68957-57-3',
  '68957-58-4',
  '68957-62-0',
  '68958-60-1',
  '68958-61-2',
  '70225-14-8',
  '70225-15-9',
  '70225-16-0',
  '70225-17-1',
  '70969-47-0',
  '70983-59-4',
  '70983-60-7',
  '71608-60-1',
  '72623-77-9',
  '72968-38-8',
  '74499-44-8',
  '78560-44-8',
  '80010-37-3',
  '82113-65-3',
  '83048-65-1',
  '865-86-1',
  '90076-65-6',
  '95144-12-0',
  '97553-95-2',
  '97659-47-7',
] as CasOrCategory[]);
